import { render, staticRenderFns } from "./booking-view-times.vue?vue&type=template&id=04fafdc2&"
import script from "./booking-view-times.vue?vue&type=script&lang=js&"
export * from "./booking-view-times.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports